import { render, staticRenderFns } from "./putOnSale.vue?vue&type=template&id=4028165a&scoped=true"
import script from "./putOnSale.vue?vue&type=script&lang=js"
export * from "./putOnSale.vue?vue&type=script&lang=js"
import style0 from "./putOnSale.vue?vue&type=style&index=0&id=4028165a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4028165a",
  null
  
)

export default component.exports